import { Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { Translation, TranslocoLoader } from '@ngneat/transloco';
import
    {
        Project,
        TranslocoClient,
        TranslocoMeta,
    } from 'Nswag/nswag-api-translation';

@Injectable({
    providedIn: 'root',
})
export class TranslocoHttpLoader implements TranslocoLoader
{
    constructor(private translocoClient: TranslocoClient) { }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get translation
     *
     * @param lang
     */
    getTranslation(lang: string): Observable<Translation>
    {
        return this.translocoClient
            .getTranslations(
                new TranslocoMeta({
                    project: Project.Admin,
                    module: 'vacancy',
                    lang: lang,
                })
            )
            .pipe(
                map(result =>
                {
                    let translation: Translation = {};
                    result?.forEach(
                        keyValue => (translation[keyValue.key] = keyValue.value)
                    );
                    return translation;
                })
            );
    }
}
